import React, { FC } from 'react'
import IconSVG, { IconSVGProps } from '../IconSVG'

const IconDoc: FC<IconSVGProps> = ({ ...props }) => (
  <IconSVG className="IconDoc" {...props}>
    <svg height="100%" width="32" viewBox="0 0 32 32" fill="currentColor">
      <path d="M9 14c0-.5523.44772-1 1-1h12c.5523 0 1 .4477 1 1s-.4477 1-1 1H10c-.55228 0-1-.4477-1-1zM9 20c0-.5523.44772-1 1-1h6c.5523 0 1 .4477 1 1s-.4477 1-1 1h-6c-.55228 0-1-.4477-1-1zM9 8c0-.55228.44772-1 1-1h12c.5523 0 1 .44772 1 1s-.4477 1-1 1H10c-.55228 0-1-.44772-1-1z" />
      <path
        fillRule="evenodd"
        d="M4 2c0-1.10457.89543-2 2-2h20c1.1046 0 2 .895431 2 2v28c0 1.1046-.8954 2-2 2H6c-1.10457 0-2-.8954-2-2V2zm2 0h20v28H6V2z"
        clipRule="evenodd"
      />
    </svg>
  </IconSVG>
)

export default IconDoc
